module.exports = ".View{\r\n    color:green;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/notification-info/notification-info.component.css
// module id = ./src/app/pages/home/notification-info/notification-info.component.css
// module chunks = main